import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';

import { useCSSColors } from '../../../../src/hooks/useCSSColors.ts';
import { ToggleViewState } from '../constants.ts';

const Wrapper = styled.button`
  z-index: 152;
  width: 100%;
  background-color: var(--color-background);
  padding: 4px 16px;
  box-shadow: inset 0px 1px 0px #ebebeb;
  display: flex;
  align-items: center;
  flex-direction: row;
  ${({ theme }) => theme.fontSize('14px')};
  line-height: 18px;
  color: var(--color-primaryText);
  cursor: pointer;
  border: none;
  position: relative;
`;

const SearchViewToggler = ({ onClickHandler, widgetState }) => {
  const colors = useCSSColors();
  const { toggleState } = widgetState.getState();

  return (
    <Wrapper onClick={onClickHandler} data-testid="SearchViewToggler">
      {toggleState === ToggleViewState.SWITCH_TO_MAP ? (
        <>
          <Icon className="icon" width={32} height={32} name="map" cdn fillColor={colors.primaryText} />
          Show map
        </>
      ) : (
        <>
          <Icon className="icon" width={32} height={32} name="list-view" cdn fillColor={colors.primaryText} />
          Show results
        </>
      )}
    </Wrapper>
  );
};

export default SearchViewToggler;
